import { ButtonProps } from "@bluframe/blublocks"

import Button from "./Button"

export interface Props extends ButtonProps {
  loading?: boolean
}

export interface ComponentProps extends Props {}

export default Button
